import { Input, Directive } from '@angular/core';

import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { GlobalTablesService } from '@common/services/global-tables-service';



declare var serverConfig: { [id: string]: any };
@Directive({
	selector: 'avatar'
})
export abstract class AvatarBase {
	@Input() userId: string;
	@Input() role: string;
	@Input() label: string;

    get shouldShowImage(): boolean {
        return this.allowAvatars && !AvatarBase.avatarErrorsByUserId[this.userId];
    }


    public static avatarErrorsByUserId: { [id: string]: boolean } = {};

	get imageUrl(): string {
		const id = this.userId || '__DEFAULT__';
        return this.nomWebServicesJson.getAvatarImageUrl(id);
	}

    get backgroundUrl(): string {
        return `url('${this.imageUrl}')`;
    }

	get userName(): string {
		return this.role || this.globalTablesService.Staff?.[this.userId]?.DisplayName || this.label;
	}

    get initials(): string {
		return this.role || this.globalTablesService.Staff?.[this.userId]?.Initials || '';
	}

    get allowAvatars(): boolean {
        return serverConfig["allowAvatars"]?.toLowerCase() === "true" || false;
    }

    onImageError() {
        AvatarBase.avatarErrorsByUserId[this.userId] = true;
    }

    imgLoaded() {
        AvatarBase.avatarErrorsByUserId[this.userId] = false;
    }

	constructor(
		public nomWebServicesJson: NomWebServicesJson,
		public globalTablesService: GlobalTablesService
	) {
	}
}
